export const hashData = async (data: string, algorithmIdentifier?: string) => {
  if (!data) {
    throw new Error('Data parameter cannot be empty');
  }

  const algorithm = algorithmIdentifier || 'SHA-256';
  const encoder = new TextEncoder();
  const dataBuffer = encoder.encode(data);
  const hashBuffer = await crypto.subtle.digest(algorithm, dataBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hexHash = hashArray
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');

  return hexHash;
};
